import { Core, Action, Decorative, TopShop } from "./build/web/palettes";

export { Core, Action, Decorative, TopShop };
